module.exports = __webpack_public_path__ + "img/team-product.f270da3f.svg";